import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Linkedin, Mail } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
import { useTheme } from '../ThemeContext';

const Footer = () => {
  const { language } = useLanguage();
  const theme = useTheme();

  const content = {
    de: {
      title: "Kontakt",
      imprint: "Impressum",
      privacy: "Datenschutz"
    },
    en: {
      title: "Contact",
      imprint: "Legal Notice",
      privacy: "Privacy Policy"
    }
  };

  const currentContent = content[language];

  return (
    <footer 
      id="contact" 
      className={`relative container mx-auto px-4 py-16 border-t ${theme.colors.borderOpacity} mt-16`}
    >
      <div className="text-center">
        <h2 className={`text-3xl font-mono mb-8 ${theme.colors.text}`}>
          {currentContent.title}
        </h2>
        <div className="flex justify-center space-x-8 mb-8">
          <a 
            href="tel:015127110726" 
            className={`${theme.colors.text} ${theme.isDarkMode ? 'hover:text-white/70' : 'hover:text-black/70'} transition-colors`}
            aria-label="Phone number"
          >
            <Phone size={32} />
          </a>
          <a 
            href="https://linkedin.com/in/yourusername" 
            className={`${theme.colors.text} ${theme.isDarkMode ? 'hover:text-white/70' : 'hover:text-black/70'} transition-colors`}
            aria-label="LinkedIn profile"
          >
            <Linkedin size={32} />
          </a>
          <a 
            href="mailto:leopold.brosig@bcre8ive.de" 
            className={`${theme.colors.text} ${theme.isDarkMode ? 'hover:text-white/70' : 'hover:text-black/70'} transition-colors`}
            aria-label="Email address"
          >
            <Mail size={32} />
          </a>
        </div>
        <div className={`flex justify-center space-x-8 text-sm ${theme.colors.textOpacity}`}>
          <Link 
            to="/legal/imprint" 
            className={`${theme.isDarkMode ? 'hover:text-white' : 'hover:text-black'} transition-colors font-mono`}
          >
            {currentContent.imprint}
          </Link>
          <Link 
            to="/legal/privacy" 
            className={`${theme.isDarkMode ? 'hover:text-white' : 'hover:text-black'} transition-colors font-mono`}
          >
            {currentContent.privacy}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

